import React from 'react';
import { CheckCircle, XCircle, AlertCircle, Info, X } from 'lucide-react';
import { useNotifications } from './NotificationContext';

const NotificationContainer = () => {
  const { notifications, removeNotification } = useNotifications();

  const getIcon = (type) => {
    switch (type) {
      case 'success': return <CheckCircle size={20} />;
      case 'error': return <XCircle size={20} />;
      case 'warning': return <AlertCircle size={20} />;
      case 'info': return <Info size={20} />;
      default: return <Info size={20} />;
    }
  };

  const getTypeStyles = (type) => {
    switch (type) {
      case 'success':
        return {
          backgroundColor: '#d4edda',
          borderColor: '#c3e6cb',
          color: '#155724',
          iconColor: '#28a745'
        };
      case 'error':
        return {
          backgroundColor: '#f8d7da',
          borderColor: '#f5c6cb',
          color: '#721c24',
          iconColor: '#dc3545'
        };
      case 'warning':
        return {
          backgroundColor: '#fff3cd',
          borderColor: '#ffeaa7',
          color: '#856404',
          iconColor: '#ffc107'
        };
      case 'info':
        return {
          backgroundColor: '#cce7ff',
          borderColor: '#b3d9ff',
          color: '#004085',
          iconColor: '#007bff'
        };
      default:
        return {
          backgroundColor: '#e2e3e5',
          borderColor: '#d6d8db',
          color: '#383d41',
          iconColor: '#6c757d'
        };
    }
  };

  if (notifications.length === 0) return null;

  return (
    <div style={{
      position: 'fixed',
      top: '80px', // Below the toolbar
      right: '20px',
      zIndex: 1000,
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      maxWidth: '400px'
    }}>
      {notifications.map((notification) => {
        const styles = getTypeStyles(notification.type);
        return (
          <div
            key={notification.id}
            className="notification-slide-in"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 16px',
              backgroundColor: styles.backgroundColor,
              border: `1px solid ${styles.borderColor}`,
              borderRadius: '8px',
              color: styles.color,
              fontSize: '14px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              position: 'relative'
            }}
          >
            <div style={{ color: styles.iconColor, flexShrink: 0 }}>
              {getIcon(notification.type)}
            </div>
            
            <div style={{ flex: 1, lineHeight: '1.4' }}>
              {notification.message}
            </div>
            
            <button
              onClick={() => removeNotification(notification.id)}
              style={{
                background: 'none',
                border: 'none',
                color: styles.color,
                cursor: 'pointer',
                padding: '0',
                display: 'flex',
                alignItems: 'center',
                opacity: 0.7,
                flexShrink: 0
              }}
              onMouseEnter={(e) => e.target.style.opacity = '1'}
              onMouseLeave={(e) => e.target.style.opacity = '0.7'}
            >
              <X size={16} />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default NotificationContainer; 